import { useCallback } from 'react';
import { useMutation } from 'src/graphql';
import { UPSERT_CAP_FINDING } from 'src/graphql/cap/mutation';

export default () => {
  const [upsertCapFinding] = useMutation(UPSERT_CAP_FINDING);

  return useCallback(
    props =>
      upsertCapFinding({
        variables: props,
      }),
    [],
  );
};
